import React, { createContext, useMemo } from 'react';
import PropTypes from 'prop-types';

const ContributeContext = createContext();

export const ContributePageProvider = ({
    campaign,
    contribution,
    step,
    canPledge,
    isReferrerLocked,
    children,
}) => {
    // We wrap the state object that we're going to expose in a
    // useMemo call to prevent unnecessary re-renders
    const value = useMemo(
        () => ({
            campaign,
            contribution,
            step,
            canPledge,
            isReferrerLocked,
        }),
        [campaign, contribution, step]
    );

    return <ContributeContext.Provider value={value}>{children}</ContributeContext.Provider>;
};

ContributePageProvider.propTypes = {
    campaign: PropTypes.shape({
        id: PropTypes.string,
        slug: PropTypes.string,
    }).isRequired,
    contribution: PropTypes.shape({
        type: PropTypes.oneOf(['pledge', 'donate']),
        amount: PropTypes.number,
    }).isRequired,
    step: PropTypes.oneOf(['type', 'amount', 'payment', 'confirm']).isRequired,
    canPledge: PropTypes.bool.isRequired,
    isReferrerLocked: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired,
};

export const ContributePageConsumer = ContributeContext.Consumer;
export default ContributeContext;
